import gql from 'graphql-tag';

export const MUTATION_SEND_REQUEST_ADVISOR_POLICY_CALL = gql`
  mutation sendRequestAdvisorPolicyCall($testatorId: ID!) {
    sendRequestAdvisorPolicyCall(testatorId: $testatorId)
  }
`;

export const MUTATION_SEND_TESTATOR_INSURANCE_APPROVAL_REQUEST = gql`
  mutation sendTestatorInsuranceApprovalRequest($testatorId: ID!) {
    sendTestatorInsuranceApprovalRequest(testatorId: $testatorId)
  }
`;
